import React, { useState, useEffect } from "react";
import styled from "styled-components";
import useMedia from "use-media";

const testMode = false;

export function GridBox({ children }) {
  return <GridBoxStyled>{children}</GridBoxStyled>;
}

const GridBoxStyled = styled.div`
  display: grid;
  gap: 3vw;
  padding: 3vw;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  @media screen and (max-width: 700px) {
    grid-template-columns: 1fr;
  }
  ${testMode && "border: 1px solid red;"}
`;

///////////

export function Col({ children }) {
  const isMob = useMedia({ maxWidth: 700 });

  if (isMob && !children) return null;

  return (
    <ColStyled style={testMode ? { border: "1px solid red" } : {}}>
      {children}
    </ColStyled>
  );
}

const ColStyled = styled.div`
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
`;

///////////

export function Line() {
  return (
    <LineStyled>
      <LineInner />
    </LineStyled>
  );
}

const LineStyled = styled.div`
  height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const LineInner = styled.div`
  background-color: black;
  height: 1px;
  width: 100%;
`;

///////////

export function Col3Span({ children }) {
  return <Col3SpanStyled>{children}</Col3SpanStyled>;
}

const Col3SpanStyled = styled.div`
  position: relative;
  /* height: 100px; */
  /* background-color: red; */
  display: flex;
  flex-direction: column;

  grid-column-start: 2;
  grid-column-end: 5;
  @media screen and (max-width: 700px) {
    grid-column-start: 1;
  }

  ${testMode && "border: 1px solid red;"}
`;
